import BaseModel from '../core/BaseModel';

export default class UseVoucherModel extends BaseModel {

    constructor() {
        super({
                name: "use_voucher",
                tableName: 'use_voucher',
                label: "use_voucher",
             
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                voucher_id: {
                    name: 'voucher_id',
                    type: "Uuid",
                    label: 'Voucher ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                uid: {
                    name: 'uid',
                    type: "Uuid",
                    label: 'User ID',
                    width: 20,
                    display: true,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                order_id: {
                    name: 'order_id',
                    type: "Uuid",
                    label: 'Order ID',
                    width: 20,
                    class: 'left',
                    filter: { type: 'input', match: 'contains' }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Created At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated At',
                    width: 10,
                    class: 'center',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    display: false
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    display: false
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "center",
                    width: 8,
                },
                voucher_discount: {
                    name: 'voucher_discount',
                    type: "Number",
                    label: 'Voucher Discount',
                    width: 10,
                    class: "right",
                },
                type: {
                    name: 'type',
                    type: "Selection",
                    label: 'Type',
                    options: [
                        { value: 1, label: 'Booking fee' },
                        { value: 2, label: 'Confirm pickup' }
                    ],
                    filter: { type: 'select', match: 'equals' },
                    width: 10,
                    class: 'center',
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Deleted",
                    display: false
                }
            })
    }
}
